import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

interface ImagePreviewProps {
  imageAlt?: string;
  imageUrl?: string;
  onChange?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const ImagePreview = ({
  imageAlt,
  imageUrl,
  onChange,
  onDelete,
}: ImagePreviewProps) => (
  <div className="bg-secondary group relative aspect-video w-full rounded-lg">
    <img
      className="size-full rounded-lg"
      src={imageUrl}
      alt={imageAlt}
      loading="lazy"
    />
    <div className="invisible absolute bottom-1/2 right-1/2 flex translate-x-1/2 translate-y-1/2 gap-4 group-hover:visible">
      <Button variant="secondary" type="button" onClick={onChange}>
        {t("change")}
      </Button>
      <Button variant="secondary" type="button" onClick={onDelete}>
        {t("remove")}
      </Button>
    </div>
  </div>
);
